import { useEffect } from 'react';

const useChildRemover = (element: HTMLDivElement | null) => {
  useEffect(() => {
    const observer = new MutationObserver((mutationList) => {
      mutationList.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          element?.removeChild(node);
        });
      });
    });

    if (element) {
      observer.observe(element, {
        attributes: false,
        childList: true,
        subtree: true,
      });
    }

    return () => observer.disconnect();
  }, []);
};

export default useChildRemover;
